// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { sendOTP, verifyOTP, resendOTP } from '../../../Config/api';

// export const useAuth = () => {
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');

//     const handleSendOTP = async (email) => {
//         setError('');
//         setLoading(true);

//         try {
//             const data = await sendOTP(email);
//             setLoading(false);
//             return { success: true, data };
//         } catch (err) {
//             setError(err.message || 'Failed to send OTP. Please try again.');
//             setLoading(false);
//             return { success: false, error: err.message };
//         }
//     };

//     const handleVerifyOTP = async (email, otpCode) => {
//         if (otpCode.length !== 6) {
//             setError('Please enter complete 6-digit code');
//             return { success: false };
//         }

//         setError('');
//         setLoading(true);

//         try {
//             const data = await verifyOTP(email, otpCode);

//             if (data.success) {
//                 localStorage.setItem('token', data.token);
//                 localStorage.setItem('user', JSON.stringify(data.user));
//                 navigate('/', { replace: true });
//                 return { success: true, data };
//             }
//         } catch (err) {
//             setError(err.message || 'Invalid verification code. Please try again.');
//             setLoading(false);
//             return { success: false, error: err.message };
//         }
//     };

//     const handleResendOTP = async (email) => {
//         setError('');
//         setLoading(true);

//         try {
//             const data = await resendOTP(email);
//             setLoading(false);
//             return { success: true, data };
//         } catch (err) {
//             setError(err.message || 'Failed to resend OTP. Please try again.');
//             setLoading(false);
//             return { success: false, error: err.message };
//         }
//     };

//     return {
//         loading,
//         error,
//         setError,
//         handleSendOTP,
//         handleVerifyOTP,
//         handleResendOTP
//     };
// };

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendOTP, verifyOTP, resendOTP, checkUserConsent } from '../../../Config/api';

export const useAuth = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSendOTP = async (email) => {
        setError('');
        setLoading(true);

        try {
            const data = await sendOTP(email);
            setLoading(false);
            return { success: true, data };
        } catch (err) {
            setError(err.message || 'Failed to send OTP. Please try again.');
            setLoading(false);
            return { success: false, error: err.message };
        }
    };

    const handleVerifyOTP = async (email, otpCode) => {
        if (otpCode.length !== 6) {
            setError('Please enter complete 6-digit code');
            return { success: false };
        }

        setError('');
        setLoading(true);

        try {
            const data = await verifyOTP(email, otpCode);

            if (data.success) {
                // Store token and user data in localStorage
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));

                // Get user data from localStorage
                const storedUser = JSON.parse(localStorage.getItem('user'));
                console.log(localStorage)

                // Check consent status - NO PAYLOAD NEEDED (token in header)
                try {
                    const consentData = await checkUserConsent();  // ✅ No userId parameter

                    setLoading(false);

                    // Navigate based on hasConsent flag
                    if (consentData.showConsent === true) {
                        // PI user - show consent form
                        navigate('/service-agreement', {
                            state: {
                                userData: storedUser
                            },
                            replace: true
                        });
                    } else if (consentData.showConsent === false) {
                        // CRO/Sponsor - show consent dashboard
                        navigate('/', {
                            state: {
                                userData: storedUser
                            },
                            replace: true
                        });
                    } else {
                        // Fallback - go to home if hasConsent is undefined
                        navigate('/', { replace: true });
                    }

                    return { success: true, data };

                } catch (consentError) {
                    console.error('Consent check failed:', consentError);
                    setLoading(false);
                    // If consent check fails, go to home page
                    navigate('/', { replace: true });
                    return { success: true, data };
                }
            }
        } catch (err) {
            setError(err.message || 'Invalid verification code. Please try again.');
            setLoading(false);
            return { success: false, error: err.message };
        }
    };

    const handleResendOTP = async (email) => {
        setError('');
        setLoading(true);

        try {
            const data = await resendOTP(email);
            setLoading(false);
            return { success: true, data };
        } catch (err) {
            setError(err.message || 'Failed to resend OTP. Please try again.');
            setLoading(false);
            return { success: false, error: err.message };
        }
    };

    return {
        loading,
        error,
        setError,
        handleSendOTP,
        handleVerifyOTP,
        handleResendOTP
    };
};